import i18n from "@/i18n"
import React from "react"
import styled from "styled-components"

const Card = styled.article`
    position: relative;
    border-radius: 18px;
    display: flex;
    min-height: 535px;
    max-width: 100%;
    width: 380px;
    flex-direction: column;
    overflow: hidden;
    justify-content: space-between;
    padding: 24px;
    margin-top: ${props => props.index === 0 ? '0' : '24px'};
    background-color: gray;
`

const CardBackgroundImg = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
`

const CardContent = styled.div`
    z-index: 1;
    display: flex;
    width: 309px;
    max-width: 100%;
    flex-direction: column;
    justify-content: start;
`

const Title = styled.h3`
    text-align: left;
    font-size: 33px;
    font-weight: 700;
    line-height: 43px;
    letter-spacing: -0.66px;
    span {
        color: white;
    }
`

const Description = styled.p`
    text-align: left;
    font-size: 16px;
    font-weight: 600;
    line-height: 25px;
    letter-spacing: -0.32px;
    margin-top: 5px;
    span {
        color: white;
    }
`

const Role = styled.p`
    color: white;
    text-align: left;
    letter-spacing: -0.46px;
    margin-top: ${props => props.marginTop};
    font: 600 23px/1 Pretendard, sans-serif;
    z-index: 1;
`

const TestimonialWrapper = styled.div`
    display: flex;
    align-items: start;
    justify-content: center;
    padding: 90px 60px;
`

const TestimonialContent = styled.div`
    display: flex;
    min-width: 240px;
    width: 100%;
    align-items: start;
    gap: 40px 49px;
    justify-content: space-between;
    flex-wrap: wrap;
    flex: 1;
    flex-basis: 0%;
`

const Heading = styled.h2`
    text-align: left;
    align-self: stretch;
    flex: 1;
    min-width: 240px;
    gap: 10px;
    color: rgba(34, 34, 34, 1);
    letter-spacing: -0.68px;
    width: 311px;
    padding: 300px 0;
    font: 800 34px/44px;
`

const HighlightText = styled.span`
    color: rgba(131,195,8,1);
`

const TestimonialContainer = styled.div`
    display: flex;
    min-width: 240px;
    flex-direction: column;
    overflow: hidden;
    color: rgba(255, 255, 255, 1);
    justify-content: start;
    width: 420px;
    padding: 0 20px 20px;
`


function TestimonialCard({ img, title, description, role, marginTop }) {
    return (
        <Card>
            <CardBackgroundImg
                src={img}
                alt=""
            />
            <CardContent>
                <Title>{
                    title.split('\n').map(item => (
                        <>
                            <span>{item}</span>
                            <br />
                        </>
                    ))}</Title>
                <Description>{
                    description.split('\n').map(desc => (
                        <>
                            <span>{desc}</span>
                            <br />
                        </>
                    ))
                }</Description>
            </CardContent>
            <Role marginTop={marginTop}>{role}</Role>
        </Card>
    )
}

export default function TestimonialSection() {
    const testimonialData = [
        {
            img: "https://front.videomonster.com/images-7cuytg20/common/newlanding2024/testimonial_1.png",
            title: i18n.t("common.landing.testimonia.title_1"),
            description: i18n.t("common.landing.testimonia.des_1"),
            role: i18n.t("common.landing.testimonia.role_1"),
            marginTop: "300px"
        },
        {
            img: "https://front.videomonster.com/images-7cuytg20/common/newlanding2024/testimonial_2.png",
            title: i18n.t("common.landing.testimonia.title_2"),
            description: i18n.t("common.landing.testimonia.des_2"),
            role: i18n.t("common.landing.testimonia.role_2"),
            marginTop: "235px"
        },
        {
            img: "https://front.videomonster.com/images-7cuytg20/common/newlanding2024/testimonial_3.png",
            title: i18n.t("common.landing.testimonia.title_3"),
            description: i18n.t("common.landing.testimonia.des_3"),
            role: i18n.t("common.landing.testimonia.role_3"),
            marginTop: "230px"
        }
    ]
    return (
        <section>
            <TestimonialWrapper>
                <TestimonialContent>
                    <Heading>
                        {i18n.t("common.landing.testimonia.text_1")} <br />
                        <HighlightText>{i18n.t("common.landing.testimonia.text_2")}</HighlightText>
                    </Heading>
                    <TestimonialContainer>
                        {testimonialData.map((testimonial, index) => (
                            <TestimonialCard key={index} {...testimonial} />
                        ))}
                    </TestimonialContainer>
                </TestimonialContent>
            </TestimonialWrapper>
        </section>
    )
}